import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
//import ModalLogin from './ModalLogin';
import Mymodal from './modal';
import Cookies from "universal-cookie";
import BusyModal from "./modalwait";
import config from '../config';
import logonorecord from "./images/recordnotfound.png";
import { withRouter } from "react-router-dom";

import { FaPrint, FaEdit, FaTrashAlt } from 'react-icons/fa';
const cookies = new Cookies();
const axios = require("axios");
class MedicalClaimListPreviousother extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            myitems: [],
            isLoaded: false,
            ErrMsg:<img src={logo} alt="Error"/>,
            ErrMsg2:"",
            ErrMsg_emp:"",
            applicant:"",
            BillAmt:0,
            DivClass: "ErrDiv"
        };
        this.handleLoad=this.handleLoad.bind(this);
        this.handleInputChangeid=this.handleInputChangeid.bind(this);
    }
    handleLoad() 
    {
        if(this.state.applicant.length > 5)
            this.functionLoad(this.state.applicant);
    }
      // handle input change
    handleInputChangeid(e)
    {
        this.setState({applicant:e.target.value});
    }
    
    handleClickDelete(index,Claimid){
        document.body.style.cursor="wait";
        this.setState({ErrMsg2:<BusyModal/>});
        var array = this.state.myitems; // make a separate copy of the array
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/medicaldelete/'+Claimid,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:""});
            if(response.data==="1")
            {
                array.splice(index,1);       
                this.setState({myitems: array,DivClass:"SuccessDiv",ErrMsg2:"Record has been Successfully removed!"});        
            }
            else
            {
                this.setState({ErrMsg2:"Unable to remove the record this moment, please try later",DivClass:"ErrDiv"});
            }
        })
        .catch(function (response) {
            this.setState({DivClass:"ErrDiv",ErrMsg2:""});
        });      
    }
    handleClickEdit(claimid,tamt){
        let input= this.state.input;
        input["ClaimID"] = claimid;
        input["st"] = "C" ;
        input["BillAmt"]=tamt;

        this.setState({input});
        this.props.history.push({
            pathname: '/MedicalFormEdit',
            data: this.state.input // your data array of objects
          })
    }

    handleClick(claimid){
        let input= this.state.input;
        input["ClaimID"] = claimid;
        input["st"] = "P";
        input["BillAmt"]=this.state.BillAmt;

        this.setState({input});
        this.props.history.push({
            pathname: '/medicalform',
            data: this.state.input // your data array of objects
        })
    }
    componentDidMount(){
 /*       if(cookies.get("LoginID"))
        {
            this.setState({applicant:cookies.get("LoginID")});
            this.functionLoad(cookies.get("LoginID"));
        }
        else
        {
            this.setState({ErrMsg:<ModalLogin mTitle={config.gvr.ErrMsgs.TitleNotLoggedin} mBody={config.gvr.ErrMsgs.MsgNotLoggedin}/>});
        }*/
    }
    functionLoad(ID){
        document.body.style.cursor="wait";
        let input=this.state.input;
        input["ID"]=ID;
        this.setState({input});
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/medicallistprevious/'+ID,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {

            if(response.data.length > 0)
            {
                this.setState({ErrMsg_emp:response.data[0].Name+" ( "+response.data[0].desig+" )"});
                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                ErrMsg:"",
                myitems: response.data
            });}
            else
                this.setState({isLoaded: false, ErrMsg2:<img src={logonorecord} alt="Not found"/>, myitems: []});
        })
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
        });  
    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;    
/*        if (!isLoaded) 
        {
            return(
                <div className="container1"> 
              <div className="center">
                {this.state.ErrMsg}
            </div>
            </div>
            );
        } 
        else 
        {*/
            return(
            <div style={{width:"100%",paddingTop:"10px",textAlign:"center",paddingLeft:"10%"}} >

            {/*<div className="container1">*/}
            <br></br>     
            <div style={{width:"100%",paddingTop:"0px",textAlign:"center"}} >
                <div className="inner-profile">
                <h5 >Medical Claim List for other</h5>
                <table style={{width:"100%", marginTop:"15px",paddingLeft:"10%"}}>
                <thead></thead>
                    <tbody>
                    <tr>
                        <td style={{width:"100px",textAlign:"left"}}>
                            <input style={{width:"100px",padding:"0px"}}
                                autoFocus="autofocus"
                                name="EmpID"
                                border="none"
                                placeholder="Employee Id"
                                onChange = {e => this.handleInputChangeid(e)}
                            />
                            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)"}} onClick={this.handleLoad}>Go </button>                  
                        </td>
                    </tr>
                    <tr style={{height:"10px"}} >
                    <td style={{textAlign:"left",width:"200px",fontWeight:"bold"}} >{this.state.ErrMsg_emp} </td>
                    </tr>
                    </tbody>
                </table>          
                <table style={{width:"100%",paddingLeft:"1%"}}>
                    <thead>
                        <tr className="tr">
                            <th className="thm" scope="col">Claim ID</th>
                            <th className="thm" scope="col">Claim Data</th>
                            <th className="thm" scope="col">Amount</th>
                            <th className="thm" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {items.map((result ,i)=>{
                    return(
                        <tr className="trc" key={i}>
                            <td className="tdm" >{result.ClaimID}</td>
                            <td className="tdm">{result.ClaimDate}</td>
                            <td className="tdm">{result.TotalAmt}</td>
                            <td className="tdm" ><button type="button"  onClick={() => {this.handleClick(result.ClaimID)}} title='View/Print'><FaPrint/></button>
                                <button type="button"  disabled = {result.claimstatus} onClick={() => {this.handleClickEdit(result.ClaimID,result.TotalAmt)}} title='Edit'><FaEdit/></button>
                                <button type="button"  disabled = {result.claimstatus} onClick={() => {this.handleClickDelete(i,result.ClaimID)}} title="Remove"><FaTrashAlt/></button>
                            </td>
                        </tr>
                    )
                    })}
                    </tbody>
                </table>
                </div>
                {this.state.ErrMsg2}
            </div>
        </div>
    );
   // }
}}
export default withRouter(MedicalClaimListPreviousother)